/**
 * WordPress dependencies.
 */
import apiFetch from "@wordpress/api-fetch";
import { __ } from "@wordpress/i18n";


import { dispatch, useSelect } from "@wordpress/data";

import { useState } from "@wordpress/element";

let updatedSettings = {};
const useSettings = () => {
  	const { createNotice } = dispatch("core/notices");
  const [status, setStatus] = useState("loading");
  const [settings, setSettings] = useState({});

  useSelect(
    (select) => {
      const { getEntityRecord } = select("core");

      // Bail out if settings are already loaded.
      if (Object.keys(settings).length) {
        return;
      }

      const request = getEntityRecord("root", "site");

      if (request) {
        setStatus("loaded");
        setSettings(request);
      }
    },
    [settings]
  );

  /**
   * Get the value of the given option.
   *
   * @param {string} option Option name.
   * @returns {any} Option value.
   */
  const getOption = (option) => {
    return updatedSettings?.[option] || settings?.[option];
  };

  /**
   * Set the value of the given option. Also set the message to be displayed on success Notice.
   *
   * @param {string} option Option name.
   * @param {any} value Option value.
   * @param {string?} success Success message for Notice.
   * @param {string?} noticeId Notice ID.
   * @param {function?} onSuccess Callback function to be executed on success.
   * @param {function?} onError Callback function to be executed on error.
   */
  const updateOption = (
    option,
    value,
    success = __("Settings saved.", "slideverse"),
    noticeId = undefined,
    onSuccess = () => {},
    onError = () => {}
  ) => {
    setStatus("saving");

    const data = {
      [option]: value,
    };

    apiFetch({
      path: "/wp/v2/settings",
      method: "POST",
      data,
    })
      .then((response) => {
        updatedSettings = response;
        setStatus("loaded");
        onSuccess();
        createNotice("success", success, {
          isDismissible: true,
          type: "snackbar",
          id: 'slideverse-settings-saved'
        });
        dispatch("core/notices").createSuccessNotice(success, {
          id: noticeId,
        });
      })
      .catch((error) => {
        setStatus("error");
        onError();
        // dispatch("core/notices").createErrorNotice(error.message, {
        //   id: noticeId,
        // });
      });

    return;
  };

  return [getOption, updateOption, status];
};

export default useSettings;
